import { executeGraphQL } from '../../../src/graphql/executeGraphQL';
import type { GraphQLRequestOverrides } from '../../../src/graphql/executeGraphQL';
import type { GqlCreateVantageInvestigationMutation, GqlCreateVantageInvestigationMutationVariables } from './CreateVantageInvestigation';
import type { GqlVantageConditionDependenciesQuery, GqlVantageConditionDependenciesQueryVariables } from './VantageConditionDependencies';
import type { GqlVantageWorksheetCreatorsQuery, GqlVantageWorksheetCreatorsQueryVariables } from './VantageWorksheetCreators';

const CreateVantageInvestigationDocument = `mutation CreateVantageInvestigation($input: VantageInvestigationInput!) {
  createVantageInvestigation(input: $input) {
    workbookId
    url
    worksheetIds
    noteErrors
  }
}`;

const VantageConditionDependenciesDocument = `query VantageConditionDependencies($conditionIds: [ID!]!, $depth: Int!) {
  vantageConditionDependencies(conditionIds: $conditionIds, depth: $depth) {
    conditionId
    dependencies {
      id
      name
      type
      fingerprint
    }
  }
}`;

const VantageWorksheetCreatorsDocument = `query VantageWorksheetCreators($workbookId: ID!) {
  workbook(id: $workbookId) {
    worksheets {
      id
      creatorId: property(name: "creatorId")
      creatorName: property(name: "creatorName")
    }
  }
}`;

export class sqVantageGqlApiClass {
  /** GraphQL mutation CreateVantageInvestigation (src/graphql/operations/vantage/CreateVantageInvestigation.graphql) */
  public createVantageInvestigation(
    variables: GqlCreateVantageInvestigationMutationVariables,
    overrides?: GraphQLRequestOverrides,
  ): Promise<GqlCreateVantageInvestigationMutation> {
    return executeGraphQL(CreateVantageInvestigationDocument, variables, overrides);
  }

  /** GraphQL query VantageConditionDependencies (src/graphql/operations/vantage/VantageConditionDependencies.graphql) */
  public vantageConditionDependencies(
    variables: GqlVantageConditionDependenciesQueryVariables,
    overrides?: GraphQLRequestOverrides,
  ): Promise<GqlVantageConditionDependenciesQuery> {
    return executeGraphQL(VantageConditionDependenciesDocument, variables, overrides);
  }

  /** GraphQL query VantageWorksheetCreators (src/graphql/operations/vantage/VantageWorksheetCreators.graphql) */
  public vantageWorksheetCreators(
    variables: GqlVantageWorksheetCreatorsQueryVariables,
    overrides?: GraphQLRequestOverrides,
  ): Promise<GqlVantageWorksheetCreatorsQuery> {
    return executeGraphQL(VantageWorksheetCreatorsDocument, variables, overrides);
  }
}

export const sqVantageGqlApi = new sqVantageGqlApiClass();
